import React, {useEffect, useState} from "react";
import BoughtTogetherPortal from "./BoughtTogetherPortal";
import RecommendationsPortal from "./RecommendationsPortal";
import SimilarProductsPortal from "./SimilarProductsPortal";
import {IItemContent, IItemSearchResponse} from "../../../typescript-library";
import {useCustomerSelector} from "../../../store";
import {PaDataType} from "./retrievalHelper";
import ProductSeriesPortal from "../../ProductSeries/ProductSeriesPortal";
import {itemsOptimizer} from "./itemsOptimizer";
import {collectCrossSellingJobs} from "./collectCrossSellingJobs";

export type ItemContainerKeyType = "productSeries" | "similarProducts" | "boughtTogether" | "recommendations";

export type ItemContainerType = {
  [key in ItemContainerKeyType]?: IItemContent[];
};

export const parentCategoriesElement = document.getElementById("ParentCategoryProductsContainer");
export const similarProductsElement = document.getElementById("PASimilarProducts");
export const boughtTogetherElement = document.getElementById("PABoughtTogether");
export const recommendationsElement = document.getElementById("PARecommendations");

const LazyCrossSelling: React.FC = () => {
  const {customer} = useCustomerSelector();
  const [itemContainer, setItemContainer] = useState<ItemContainerType>({});

  useEffect(() => {
    const jobs: Promise<PaDataType | IItemSearchResponse>[] = collectCrossSellingJobs();

    if (jobs.length) {
      void Promise.all<IItemSearchResponse | PaDataType>(jobs).then(async (paResults) => {
        let itemContent: IItemContent[] = [];
        if (
          (paResults[0] as IItemSearchResponse).itemContent
        ) {
          // When first entry is set, product series and collections response can be set directly into the `itemContainer`
          itemContent = (paResults.shift() as IItemSearchResponse).itemContent;
          if (itemContent.length) {
            setItemContainer({productSeries: itemContent});
          }
        }

        const newItemContainer = await itemsOptimizer(paResults as PaDataType[], customer, itemContent);

        setItemContainer((prevState) => ({
          ...prevState,
          ...newItemContainer,
        }));
      });
    }
  }, []);

  return (
    <React.Fragment>
      {/* Keep in mind that the order is determined by the order of the corresponding <section>s in the .xsl markup */}
      {parentCategoriesElement && itemContainer.productSeries?.length && (
        <ProductSeriesPortal element={parentCategoriesElement} items={itemContainer.productSeries} />
      )}
      {boughtTogetherElement && itemContainer.boughtTogether?.length && (
        <BoughtTogetherPortal element={boughtTogetherElement} items={itemContainer.boughtTogether} />
      )}
      {similarProductsElement && itemContainer.similarProducts?.length && (
        <SimilarProductsPortal element={similarProductsElement} items={itemContainer.similarProducts} />
      )}
      {recommendationsElement && itemContainer.recommendations?.length && (
        <RecommendationsPortal element={recommendationsElement} items={itemContainer.recommendations} />
      )}
    </React.Fragment>
  );
};

export default LazyCrossSelling;
